import React from "react";
import PropTypes from "prop-types";
import BlogArticleCard from "./BlogArticleCard";

const BlogArticleHome = ({ article }) => {
  return (
    <BlogArticleCard
      article={article}
      imageClassName="md:min-h-full md:min-w-ful md:h-auto md:w-48">
      <h3 className="text-md items-start mb-3">{article.title}</h3>
    </BlogArticleCard>
  );
};

BlogArticleHome.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    metadata: PropTypes.object,
  }).isRequired,
};

export default BlogArticleHome;
